/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const messagesByConversationId = /* GraphQL */ `
  query MessagesByConversationId(
    $conversationId: String!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversationId(
      conversationId: $conversationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        content
        name
        direction
        phoneNumber
        timestamp
        read
        readAt
        messageSid
        mediaUrls
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationsBySubmissionId = /* GraphQL */ `
  query ConversationsBySubmissionId(
    $submissionId: String!
    $lastMessageTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    conversationsBySubmissionId(
      submissionId: $submissionId
      lastMessageTime: $lastMessageTime
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubmission = /* GraphQL */ `
  query GetSubmission($id: ID!) {
    getSubmission(id: $id) {
      id
      publicId
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      sendwelcomesms
      state
      transgender
      updatedAt
      zipcode
      Status
      updatedBy
      Notes
      userscore
      eligible
      needsAlternateTime
      alternateTimeRequestedAt
      conversations {
        items {
            id
            submissionId
            lastMessageTime
            status
            unreadCount
            lastMessageContent
          }      
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      statusHistory {
        nextToken
        __typename
      }
      messageVariants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSubmissions = /* GraphQL */ `
  query ListSubmissions(
    $filter: ModelSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubmissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubmissionStatusHistory = /* GraphQL */ `
  query GetSubmissionStatusHistory($id: ID!) {
    getSubmissionStatusHistory(id: $id) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      previousStatus
      newStatus
      changedAt
      changedBy
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubmissionStatusHistories = /* GraphQL */ `
  query ListSubmissionStatusHistories(
    $filter: ModelSubmissionStatusHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubmissionStatusHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        previousStatus
        newStatus
        changedAt
        changedBy
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      createdAt
      lastMessageTime
      updatedAt
      status
      unreadCount
      lastMessageContent
      lastMessageDirection
      twilioConversationSid
      messages {
        nextToken
        __typename
      }
      participants {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      content
      name
      direction
      phoneNumber
      timestamp
      read
      readAt
      messageSid
      mediaUrls
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationId
        content
        name
        direction
        phoneNumber
        timestamp
        read
        readAt
        messageSid
        mediaUrls
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getParticipant = /* GraphQL */ `
  query GetParticipant($id: ID!) {
    getParticipant(id: $id) {
      id
      conversationId
      conversation {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      phoneNumber
      twilioSid
      name
      role
      isRequired
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listParticipants = /* GraphQL */ `
  query ListParticipants(
    $filter: ModelParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listParticipants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationId
        phoneNumber
        twilioSid
        name
        role
        isRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDuplicateSubmission = /* GraphQL */ `
  query GetDuplicateSubmission($id: ID!) {
    getDuplicateSubmission(id: $id) {
      id
      SID
      createdAt
      mobilenumber
      age
      gender
      householdincome
      state
      transgender
      updatedAt
      zipcode
      originalSubmissionId
      __typename
    }
  }
`;
export const listDuplicateSubmissions = /* GraphQL */ `
  query ListDuplicateSubmissions(
    $filter: ModelDuplicateSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDuplicateSubmissions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        state
        transgender
        updatedAt
        zipcode
        originalSubmissionId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAppointmentSlot = /* GraphQL */ `
  query GetAppointmentSlot($id: ID!) {
    getAppointmentSlot(id: $id) {
      id
      date
      startTime
      endTime
      isBooked
      createdBy
      updatedBy
      createdAt
      updatedAt
      appointment {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listAppointmentSlots = /* GraphQL */ `
  query ListAppointmentSlots(
    $filter: ModelAppointmentSlotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointmentSlots(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAppointment = /* GraphQL */ `
  query GetAppointment($id: ID!) {
    getAppointment(id: $id) {
      id
      slotId
      slot {
        id
        date
        startTime
        endTime
        isBooked
        createdBy
        updatedBy
        createdAt
        updatedAt
        __typename
      }
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      bookedAt
      status
      updatedBy
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAppointments = /* GraphQL */ `
  query ListAppointments(
    $filter: ModelAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessageTemplate = /* GraphQL */ `
  query GetMessageTemplate($id: ID!) {
    getMessageTemplate(id: $id) {
      id
      type
      content
      isActive
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const listMessageTemplates = /* GraphQL */ `
  query ListMessageTemplates(
    $filter: ModelMessageTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        content
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOffHoursConfig = /* GraphQL */ `
  query GetOffHoursConfig($id: ID!) {
    getOffHoursConfig(id: $id) {
      id
      isEnabled
      weekdayStartTime
      weekdayEndTime
      weekendStartTime
      weekendEndTime
      updatedAt
      updatedBy
      createdAt
      __typename
    }
  }
`;
export const listOffHoursConfigs = /* GraphQL */ `
  query ListOffHoursConfigs(
    $filter: ModelOffHoursConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOffHoursConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isEnabled
        weekdayStartTime
        weekdayEndTime
        weekendStartTime
        weekendEndTime
        updatedAt
        updatedBy
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAppointmentMessageVariantTemplate = /* GraphQL */ `
  query GetAppointmentMessageVariantTemplate($id: ID!) {
    getAppointmentMessageVariantTemplate(id: $id) {
      id
      variantTrack
      messageType
      content
      isActive
      mrt
      response1
      response2
      createdAt
      updatedAt
      createdBy
      updatedBy
      __typename
    }
  }
`;
export const listAppointmentMessageVariantTemplates = /* GraphQL */ `
  query ListAppointmentMessageVariantTemplates(
    $filter: ModelAppointmentMessageVariantTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointmentMessageVariantTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        variantTrack
        messageType
        content
        isActive
        mrt
        response1
        response2
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserMessageVariant = /* GraphQL */ `
  query GetUserMessageVariant($id: ID!) {
    getUserMessageVariant(id: $id) {
      id
      submissionId
      submission {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      status
      variantTrack
      assignedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserMessageVariants = /* GraphQL */ `
  query ListUserMessageVariants(
    $filter: ModelUserMessageVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserMessageVariants(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        status
        variantTrack
        assignedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const submissionsByMobileNumber = /* GraphQL */ `
  query SubmissionsByMobileNumber(
    $mobilenumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    submissionsByMobileNumber(
      mobilenumber: $mobilenumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        publicId
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        sendwelcomesms
        state
        transgender
        updatedAt
        zipcode
        Status
        updatedBy
        Notes
        userscore
        eligible
        needsAlternateTime
        alternateTimeRequestedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const submissionStatusHistoriesBySubmissionIdAndChangedAt = /* GraphQL */ `
  query SubmissionStatusHistoriesBySubmissionIdAndChangedAt(
    $submissionId: ID!
    $changedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSubmissionStatusHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    submissionStatusHistoriesBySubmissionIdAndChangedAt(
      submissionId: $submissionId
      changedAt: $changedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        previousStatus
        newStatus
        changedAt
        changedBy
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationsBySubmissionIdAndLastMessageTime = /* GraphQL */ `
  query ConversationsBySubmissionIdAndLastMessageTime(
    $submissionId: ID!
    $lastMessageTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationsBySubmissionIdAndLastMessageTime(
      submissionId: $submissionId
      lastMessageTime: $lastMessageTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationsByTwilioConversationSid = /* GraphQL */ `
  query ConversationsByTwilioConversationSid(
    $twilioConversationSid: String!
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationsByTwilioConversationSid(
      twilioConversationSid: $twilioConversationSid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        createdAt
        lastMessageTime
        updatedAt
        status
        unreadCount
        lastMessageContent
        lastMessageDirection
        twilioConversationSid
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByConversationIdAndTimestamp = /* GraphQL */ `
  query MessagesByConversationIdAndTimestamp(
    $conversationId: ID!
    $timestamp: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByConversationIdAndTimestamp(
      conversationId: $conversationId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        content
        name
        direction
        phoneNumber
        timestamp
        read
        readAt
        messageSid
        mediaUrls
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messagesByMessageSid = /* GraphQL */ `
  query MessagesByMessageSid(
    $messageSid: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByMessageSid(
      messageSid: $messageSid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        content
        name
        direction
        phoneNumber
        timestamp
        read
        readAt
        messageSid
        mediaUrls
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const participantsByConversationIdAndPhoneNumber = /* GraphQL */ `
  query ParticipantsByConversationIdAndPhoneNumber(
    $conversationId: ID!
    $phoneNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    participantsByConversationIdAndPhoneNumber(
      conversationId: $conversationId
      phoneNumber: $phoneNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        phoneNumber
        twilioSid
        name
        role
        isRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const participantsByTwilioSid = /* GraphQL */ `
  query ParticipantsByTwilioSid(
    $twilioSid: String!
    $sortDirection: ModelSortDirection
    $filter: ModelParticipantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    participantsByTwilioSid(
      twilioSid: $twilioSid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationId
        phoneNumber
        twilioSid
        name
        role
        isRequired
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const duplicateSubmissionsByMobilenumber = /* GraphQL */ `
  query DuplicateSubmissionsByMobilenumber(
    $mobilenumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDuplicateSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    duplicateSubmissionsByMobilenumber(
      mobilenumber: $mobilenumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        state
        transgender
        updatedAt
        zipcode
        originalSubmissionId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const duplicateSubmissionsByOriginalSubmissionId = /* GraphQL */ `
  query DuplicateSubmissionsByOriginalSubmissionId(
    $originalSubmissionId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDuplicateSubmissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    duplicateSubmissionsByOriginalSubmissionId(
      originalSubmissionId: $originalSubmissionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        SID
        createdAt
        mobilenumber
        age
        gender
        householdincome
        state
        transgender
        updatedAt
        zipcode
        originalSubmissionId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const appointmentsBySlotId = /* GraphQL */ `
  query AppointmentsBySlotId(
    $slotId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appointmentsBySlotId(
      slotId: $slotId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const appointmentsBySubmissionId = /* GraphQL */ `
  query AppointmentsBySubmissionId(
    $submissionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appointmentsBySubmissionId(
      submissionId: $submissionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slotId
        submissionId
        bookedAt
        status
        updatedBy
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const messageTemplatesByType = /* GraphQL */ `
  query MessageTemplatesByType(
    $type: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMessageTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messageTemplatesByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        content
        isActive
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const appointmentMessageVariantTemplatesByVariantTrackAndMessageType = /* GraphQL */ `
  query AppointmentMessageVariantTemplatesByVariantTrackAndMessageType(
    $variantTrack: Int!
    $messageType: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAppointmentMessageVariantTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    appointmentMessageVariantTemplatesByVariantTrackAndMessageType(
      variantTrack: $variantTrack
      messageType: $messageType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        variantTrack
        messageType
        content
        isActive
        mrt
        response1
        response2
        createdAt
        updatedAt
        createdBy
        updatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userMessageVariantsBySubmissionIdAndStatus = /* GraphQL */ `
  query UserMessageVariantsBySubmissionIdAndStatus(
    $submissionId: ID!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserMessageVariantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userMessageVariantsBySubmissionIdAndStatus(
      submissionId: $submissionId
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        submissionId
        status
        variantTrack
        assignedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
